import React, { useEffect } from 'react'
import { UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem, Input2FA } from '@node-space/ui-components'
import { TWO_FA_REQUIRED_LENGTH } from 'components/TwoFA/TwoFAField'
import { UpdateBeneficiaryFormPayload } from 'types/beneficiaries'

type EditBeneficiaryConfirmProps = {
  beneficiaryUpdatedDetails: UpdateBeneficiaryFormPayload
  isBusiness: boolean
  otpError?: boolean
  isLoading: boolean
  password: string
  onEditSubmit: () => void
  register: UseFormRegister<UpdateBeneficiaryFormPayload>
  setValue: UseFormSetValue<UpdateBeneficiaryFormPayload>
}

export const EditBeneficiaryConfirm = ({
  beneficiaryUpdatedDetails,
  isBusiness,
  otpError,
  isLoading,
  password,
  onEditSubmit,
  register,
  setValue,
}: EditBeneficiaryConfirmProps) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (password?.length === TWO_FA_REQUIRED_LENGTH) {
      onEditSubmit?.()
    }
  }, [password])

  return (
    <Box flexCol paddingX={24} paddingY={20}>
      <Box key={beneficiaryUpdatedDetails?.alias} width="full">
        {isBusiness ? (
          <DataListItem
            id="business-name"
            title={t('businessName')}
            body={beneficiaryUpdatedDetails?.businessName}
          />
        ) : (
          <DataListItem
            id="first-and-last-name"
            title={t('manageBeneficiaries.firstAndLastName')}
            body={`${beneficiaryUpdatedDetails?.firstName ?? ''} ${beneficiaryUpdatedDetails?.lastName ?? ''}`}
          />
        )}

        <DataListItem
          id="alias"
          title={t('manageBeneficiaries.beneficiaryDescription')}
          body={beneficiaryUpdatedDetails?.alias}
        />
      </Box>

      <Box paddingT={24} paddingB={12}>
        <Input2FA
          {...register('password')}
          label={t('authCodeConfirm')}
          onChange={value => setValue('password', value)}
          testId="input-2fa"
          error={otpError && t('incorrectOtpCode')}
          loading={isLoading}
        />
      </Box>
    </Box>
  )
}
